// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ContextualHelp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.4 4.6l-.7.7.7-.7C22.6 1.8 18.9.3 15 .3S7.4 1.8 4.6 4.6.3 11.1.3 15s1.5 7.6 4.3 10.4 6.5 4.3 10.4 4.3 7.6-1.5 10.4-4.3 4.3-6.5 4.3-10.4-1.5-7.6-4.3-10.4zM24 24c-2.4 2.4-5.6 3.7-9 3.7S8.4 26.4 6 24s-3.7-5.6-3.7-9S3.6 8.4 6 6s5.6-3.7 9-3.7 6.6 1.3 9 3.7 3.7 5.6 3.7 9-1.3 6.6-3.7 9z"/><path d="M15 12c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1v-8c0-.6.4-1 1-1zm0-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"/></svg>;
};

export default React.memo(ContextualHelp);
